import 'es6-promise/auto';
import * as React from 'react';
import * as _ from 'lodash';
import { PerformanceViewModel, ErrorStatus, SectionSelect} from './classes';
import { array } from 'prop-types';

interface PerformanceAddOnsDisplayFormProps
{
    production: PerformanceViewModel;
    key: number;
}

interface PerformanceAddOnsDisplayFormState
{
    production: PerformanceViewModel;
    sections: Array<SectionSelect>;
    enableSectionDropdown: boolean;
}

const quantitySelector = [0,1,2,3,4,5,6,7,8,9,10]

class PerformanceAddOnsDisplaySelection extends React.Component<PerformanceAddOnsDisplayFormProps, PerformanceAddOnsDisplayFormState>{
    constructor(props) {
        super(props)
        this.state = {
            production: this.props.production,
            enableSectionDropdown: false,
            sections: this.props.production.sections
        }
        this.failedToReserve = this.failedToReserve.bind(this);
    }

    dateSelectedForProduction(e: any):void{
        var performanceId = e.target.value;
        var prod = this.state.production;
        prod.performanceId = performanceId;
        this.setState({
            production: prod
        })
    }
    zoneSelectedForProduction(e: any): void{
        let zoneID = e.target.value as number;
        let prod = this.state.production;
        prod.zoneId = zoneID;
        this.setState({
            production: prod
        })
    }

    priceTypeSelectionChange(e: any): void {
        let priceTypeId = e.target.value as number;
        if (priceTypeId > -1) {
            let prod = this.state.production;
            prod.priceTypeId = priceTypeId;
            this.setState({
                enableSectionDropdown: true
            });
            this.filterSectionByPriceType(priceTypeId);
        } else {
            this.setState({
                enableSectionDropdown: false
            });
        }
    }

    filterSectionByPriceType(priceType: number): void {
        var filteredSection = this.state.production.sections.filter(x => x.priceTypeID == priceType);
        this.setState({
            sections: filteredSection
        })
    }
    quantitySelectedForProduction(e: any):void{
        var quantityId = e.target.value;
        var prod = this.state.production;
        prod.quantity = quantityId;
        this.setState({
            production: prod
        })
    }

    componentWillReceiveProps(props) {
        const { production } = this.props;
        if (props.production !== production) {
            this.setState({
                production: props.production
            })
        }
    }

    failedToReserve(value: number, isPerformance: boolean) {
        if (isPerformance) {
            return this.state.production.performanceId === value;
        }
        else if (!isPerformance) {
            return this.state.production.zoneId === value;
        }
    }

    
    render(){
        return (
            <div className="addons-performance-options">
                <div className="addons-performance-options-inner">
                <div>
                <select value={this.state.production.performanceId} name="performance-select" onChange={this.dateSelectedForProduction.bind(this)} >
                    <option selected value="-1"  > Select a date</option>
                    {
                        this.state.production.performanceDates.map((value) => {
                                return (<option value={value.performanceId} disabled={this.failedToReserve(value.performanceId, true) ? true : false} >{value.dateTime}</option>)
                        })
                    }
                    </select>
                    {
                        (this.state.production.performanceReserveFail && this.state.production.status === ErrorStatus.Performance) ?
                            (<b>{this.state.production.errorMessage}</b>)
                        :
                        (<div></div>)
                    }
                </div>
                    <div>
                        <select value={this.state.production.priceTypeId} name="zone-select" onChange={this.priceTypeSelectionChange.bind(this)}>
                            <option selected value="-1" >Select a price type</option>
                            {
                                this.state.production.priceTypes.map((value, index) => {
                                    return (<option value={value.priceTypeID} >{value.priceTypeDescription}</option>)
                                })
                            }
                        </select>
                </div>
                    <div>
                        <select value={this.state.production.zoneId} disabled={!this.state.enableSectionDropdown} name="zone-select" onChange={this.zoneSelectedForProduction.bind(this)}>
                    <option selected value="-1" >Select a zone</option>
                    {
                                this.state.sections.map((value, index) => {
                                    return (<option value={value.sectionId} disabled={this.failedToReserve(value.sectionId, false) ? true : false}  >{value.sectionDescription}</option>)
                        })
                    }
                    </select>
                    {
                        (this.state.production.performanceReserveFail && this.state.production.status === ErrorStatus.Section) ?
                            (<b>{this.state.production.errorMessage}</b>)
                            :
                            (<div></div>)
                    }
                </div>
                <div className="addons-performance-options-number">
                <select value={this.state.production.quantity} name="quantity-select" onChange={this.quantitySelectedForProduction.bind(this)}>
                    {
                        quantitySelector.map((value, index) => {
                            return(<option value={value}>{value}</option>)
                        })
                    }
                </select>
                    </div>
                </div>
                <div className="error">
                    {
                        (this.state.production.performanceReserveFail && this.state.production.status === ErrorStatus.General) ?
                            (<b>{this.state.production.errorMessage}</b>)
                            : 
                            (<div></div>)
                    }
                </div>
            </div>
        );
    }
}

export default PerformanceAddOnsDisplaySelection;